"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SrText", {
    enumerable: true,
    get: function() {
        return SrText;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const SrText = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _react.default.createElement("span", {
        className: "jsx-cf686a6633ad994b"
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "cf686a6633ad994b"
    }, "span.jsx-cf686a6633ad994b{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}"));
};

//# sourceMappingURL=SrText.js.map